import { DataTableCollapsibleRow, Loader } from "@/components";
import { Button } from "@/components/ui";
import useSquareFootage from "./useSquareFootage";
import { Building2, Home } from "lucide-react";

const SquareFootage = () => {
  const {
    columns,
    subColumns,
    level2Columns,
    tableData,
    isLoadingRules,
    isLoadingMetricInfo,
    tableRef,
    isAllExpanded,
    onExpandStateChange,
    onExpandCollapse
  } = useSquareFootage();

  return (
    <>
      {isLoadingMetricInfo || isLoadingRules ? <Loader /> : 
        <div>
          <div className="bg-white rounded-t-lg flex flex-col md:flex-row md:items-start md:justify-between gap-3 p-5 pb-3">
            <div>
              <h3 className="text-[16px] font-semibold text-primary">
                Metric Value
              </h3>
              <p className="text-[12px] text-g-400 mt-1">
                Values used as allocation basis for receiver allocations.
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-end gap-2">
              <Button
                type="button"
                onClick={onExpandCollapse}
                className="h-[36px] w-[120px] text-[14px]"
              >
                {isAllExpanded ? "Collapse All" : "Expand All"}
              </Button>
            </div>
          </div>

            <DataTableCollapsibleRow
              ref={tableRef}
              columns={columns}
              nestedColumns={[subColumns, level2Columns]}
              data={tableData}
              containerClassName="border-0 shadow-none rounded-t-none px-4"
              onExpandStateChange={onExpandStateChange}
              variant="secondary"
              hideFooter
              hideHeader={{
                level2: true
              }}
              icons={{
                level1: <div className="p-2 flex items-center justify-center bg-blue-50 rounded-md shadow-sm">
                  <Building2 className="h-5 stroke-primary" />
                </div>,
                level2: <div className="p-2 flex items-center justify-center bg-blue-50 rounded-md shadow-sm">
                  <Building2 className="h-5 stroke-primary" />
                </div>,
                level3: <div className="p-2 flex items-center justify-center bg-blue-50 rounded-md shadow-sm">
                  <Home className="h-5 stroke-primary" />
                </div>
              }}
            />
        </div>
      }
    </>
  )
}

export default SquareFootage;